require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ppb-behavioral-health.json") })
        }
      }, "path---ppb-behavioral-health");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ppb-behavioral-health!./.cache/json/ppb-behavioral-health.json
// module id = 958
// module chunks = 231608221292675